import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const customerTypeModURL = "api/v1/customer-master-app/customer-type";
//obtaining the paginated data
export const getCustomerType = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${customerTypeModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllCustomerType = () => axiosInstance.get(`${customerTypeModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageCustomerType = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${customerTypeModURL}/list?offset=${(number - 1) * rowsPerPage}&limit=${rowsPerPage}&ordering=-id`
  );

//creating function
export const createCustomerType = (body) => axiosInstance.post(`${customerTypeModURL}/create`, body);
//updating function
export const updateCustomerType = (id, body) => axiosInstance.patch(`${customerTypeModURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${customerTypeModURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataCustomerTypeName = (e, cancelToken) =>
  axiosInstance.get(`${customerTypeModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
